export function FormatTimeDifference(updatedOn) {
  const currentTimestamp = Math.floor(new Date().getTime() / 1000);
  const dateObject = new Date(updatedOn);
  const unixTimestamp = Math.floor(dateObject.getTime() / 1000);
  const timeDifferenceInSeconds = currentTimestamp - unixTimestamp;

  if (timeDifferenceInSeconds < 60 && timeDifferenceInSeconds >= 0) {
    return `${timeDifferenceInSeconds} ${timeDifferenceInSeconds !== 1 ? 'seconds' : 'second'} ${'ago'}`;
  } else if (timeDifferenceInSeconds < 3600) {
    const minutes = Math.floor(timeDifferenceInSeconds / 60);
    return `${minutes} ${minutes !== 1 ? 'minutes' : 'minute'} ${'ago'}`;
  } else if (timeDifferenceInSeconds < 86400) {
    const hours = Math.floor(timeDifferenceInSeconds / 3600);
    return `${hours} ${hours !== 1 ? 'hours' : 'hour'} ${'ago'}`;
  } else if (timeDifferenceInSeconds < 604800) {
    const days = Math.floor(timeDifferenceInSeconds / 86400);
    return `${days} ${days !== 1 ? 'days' : 'day'} ${'ago'}`;
  } else if (timeDifferenceInSeconds < 2628000) {
    const weeks = Math.floor(timeDifferenceInSeconds / 604800);
    return `${weeks} ${weeks !== 1 ? 'weeks' : 'week'} ${'ago'}`;
  } else if (timeDifferenceInSeconds < 31536000) {
    const months = Math.floor(timeDifferenceInSeconds / 2628000);
    return `${months} ${months !== 1 ? 'months' : 'month'} ${'ago'}`;
  } else {
    const years = Math.floor(timeDifferenceInSeconds / 31536000);
    return `${years} ${years !== 1 ? 'years' : 'year'} ${'ago'}`;
  }
}

// Parse a backend timestamp as UTC. Timestamps arrive both with an explicit
// offset ("2026-07-28T03:06:14+00:00") and without ("2026-07-28T03:06:14");
// only bare strings get a 'Z' appended — appending 'Z' to an offset-bearing
// string yields an Invalid Date, which rendered as "NaN years ago" (PROD-671).
export function parseUTCDate(value) {
  if (!value) return null;
  if (value instanceof Date) return isNaN(value.getTime()) ? null : value;
  const s = String(value).trim();
  const hasTimezone = /(Z|[+-]\d{2}:?\d{2})$/i.test(s);
  const date = new Date(hasTimezone ? s : s + 'Z');
  return isNaN(date.getTime()) ? null : date;
}

export function formatTimeDifferenceUTC(utcTimeString) {
  const updatedOn = parseUTCDate(utcTimeString);
  if (!updatedOn) return '';
  const currentTimestamp = Math.floor(Date.now() / 1000);
  const unixTimestamp = Math.floor(updatedOn.getTime() / 1000);
  // Clock skew can put a fresh server timestamp a few seconds in the future.
  const timeDifferenceInSeconds = Math.max(0, currentTimestamp - unixTimestamp);

  if (timeDifferenceInSeconds < 60) {
    return `${timeDifferenceInSeconds} ${timeDifferenceInSeconds !== 1 ? 'seconds' : 'second'} ago`;
  } else if (timeDifferenceInSeconds < 3600) {
    const minutes = Math.floor(timeDifferenceInSeconds / 60);
    return `${minutes} ${minutes !== 1 ? 'minutes' : 'minute'} ago`;
  } else if (timeDifferenceInSeconds < 86400) {
    const hours = Math.floor(timeDifferenceInSeconds / 3600);
    return `${hours} ${hours !== 1 ? 'hours' : 'hour'} ago`;
  } else if (timeDifferenceInSeconds < 604800) {
    const days = Math.floor(timeDifferenceInSeconds / 86400);
    return `${days} ${days !== 1 ? 'days' : 'day'} ago`;
  } else if (timeDifferenceInSeconds < 2628000) {
    const weeks = Math.floor(timeDifferenceInSeconds / 604800);
    return `${weeks} ${weeks !== 1 ? 'weeks' : 'week'} ago`;
  } else if (timeDifferenceInSeconds < 31536000) {
    const months = Math.floor(timeDifferenceInSeconds / 2628000);
    return `${months} ${months !== 1 ? 'months' : 'month'} ago`;
  } else {
    const years = Math.floor(timeDifferenceInSeconds / 31536000);
    return `${years} ${years !== 1 ? 'years' : 'year'} ago`;
  }
}
